import moment from 'moment';
import { cpf as cpfValidator, cnpj as cnpjValidator } from 'cpf-cnpj-validator';
import { encrypt, decrypt, eaPassword } from './crypto'
import { nomesMeses } from './constants';

// Criptografa um objeto
export function encryptObject(data) {
    return encodeURIComponent(encrypt(encodeURIComponent(JSON.stringify(data)), eaPassword));
}

// Decriptografa um objeto
export function decryptObject(dataStr) {
    return JSON.parse(decodeURIComponent(decrypt(decodeURIComponent(dataStr), eaPassword)));
}

export function serialize(obj) {
    var str = [];
    for (var p in obj)
        if (obj.hasOwnProperty(p)) {
            str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
        }

    return str.join("&");
}

// Validadores

export function validarCPF(cpf) {
    return cpfValidator.isValid(cpf)
}

export function validarCNPJ(cnpj) {
    return cnpjValidator.isValid(cnpj)
}

// Formatações de valores
export function formataCnpj(cnpj = '') {
    if(cnpj.length>0){
        if(cnpjValidator.isValid(cnpj)){
            return cnpjValidator.format(cnpj);
        }
        return cnpj;
    }
    
    return '-';
}

export function formataNit(nit = ''){
    if(nit.length>0){
        if(nit.length === 11){
            let part1 = nit.slice(0,3);
            let part2 = nit.slice(3,8);
            let part3 = nit.slice(8,10);
            let part4 = nit.slice(10,11);
            return `${part1}.${part2}.${part3}-${part4}`;
        }
        return nit;
    }
    
    return '-';
}

export function formataCpf(cpf) {
    return cpfValidator.format(cpf);
}

export function removeCharactersAndSpecialCharacter(value = '') {
    return value.replace(/[^0-9]/g, "");
}

export function customReplace(str, oldStr, newStr) {
    return str.split(oldStr).join(newStr);
}

export function retirarFormatacaoCPF(cpf) {
    if (!cpf) return "";

    let cpfAux = customReplace(cpf, ".", "");
    cpfAux = customReplace(cpfAux, "_", "");
    cpfAux = customReplace(cpfAux, "-", "");
    cpfAux = customReplace(cpfAux, "/", "");

    return cpfAux;
}

export function retirarFormatacaoNumber(porcentagem) {
    if (!porcentagem) return;

    let porcentagemAux = customReplace(porcentagem, ".", "");
    porcentagemAux = customReplace(porcentagemAux, " ", "");
    porcentagemAux = customReplace(porcentagemAux, "R$", "");
    porcentagemAux = customReplace(porcentagemAux, "%", "");
    porcentagemAux = customReplace(porcentagemAux, ",", ".");

    if (!porcentagem) return;

    porcentagemAux = parseFloat(porcentagemAux);

    return porcentagemAux;
}

export function formatarPorcentagem(value, oldValue = "") {
    if (oldValue && value && !value.includes("%") && oldValue.includes("%")) {
        value = value.substring(0, value.length - 1);
    }

    if (Number.isNaN(parseInt(removeCharactersAndSpecialCharacter(value)))) {
        return "";
    } else {
        return mascaraPorcentagem(value);
    }
}

export function formatarReaisInput(value) {
    value = removeCharactersAndSpecialCharacter(value);
    if (Number.isNaN(parseFloat(value + ""))) {
        return "";
    } else {
        value = parseFloat(value + "");
        value = value * 0.01;

        value = value.toLocaleString("pt-BR", { minimumFractionDigits: 2 });
        return "R$ " + value;
    }
}

export function formatarReais(value) {
    if (parseFloat(value) < 0) {
        value = 0
    }

    value = parseFloat(value + "");

    value = value.toLocaleString("pt-BR", { minimumFractionDigits: 2 });
    return "R$ " + value;
}

export function formataData(data, format) {
    return data.length > 10 ? moment(data).format(format || "DD/MM/YYYY") : data;
}

export function mascaraPorcentagem(value) {
    let newValue = removeCharactersAndSpecialCharacter(value);
    newValue = parseFloat(newValue + ",");
    newValue = newValue * 0.01;
    newValue = Number(newValue).toFixed(2).toString().replace(".", ",") + "%";

    return newValue;
}

export function formataNomeCompetencia(competencia = '') {
    if(competencia.length>0){
        let competenciaSplit = competencia.split('/');
        if(competenciaSplit.length===2){
            let intMes = parseInt(competenciaSplit[0]);
            if(!Number.isNaN(intMes)){
                return nomesMeses[intMes];
            }
        }        
    }
    
    return '-';
}